import { cn } from '@/utils/cn';

interface LogoProps {
  src: string;
  height: number;
  className?: string;
}
export function Logo({ src, height, className }: LogoProps) {
  return (
    <img
      className={cn(`h-${height}`, className ? className : '')}
      src={src}
      alt={'logo'}
    />
  );
}
